const notificationData = [
    {
        image: '/assets/images/newimages/userimg.jpg',
        name: '[Member Name] has joined your organization. Assign them to a project to get started.',
        viewBtn: 'View Timesheet',
        undoBtn: '',
        dateVal: ''
    },
    {
        image: '',
        name: 'Your timesheet for April 1–7 has been submitted successfully.',
        viewBtn: 'View Timesheet',
        undoBtn: 'Undo',
        dateVal: 'Today at 9:42 AM'
    },
    {
        image: '',
        name: 'Your timesheet for March 25–31 is now locked and cannot be edited.',
        viewBtn: 'View Summary',
        undoBtn: '',
        dateVal: 'Last Wednesday at 9:42 AM'
    },
    {
        image: '/assets/images/newimages/userimg.jpg',
        name: '[Member Name] has joined your organization. Assign them to a project to get started.',
        viewBtn: 'View Timesheet',
        undoBtn: '',
        dateVal: ''
    },
    {
        image: '',
        name: 'Your timesheet for April 1–7 has been submitted successfully.',
        viewBtn: 'View Timesheet',
        undoBtn: 'Undo',
        dateVal: 'Today at 9:42 AM'
    },
    {
        image: '',
        name: 'Your timesheet for March 25–31 is now locked and cannot be edited.',
        viewBtn: 'View Summary',
        undoBtn: '',
        dateVal: 'Last Wednesday at 9:42 AM'
    },
]

export default notificationData